import Debug from "./debug";
import Module from "../framework/core/mvvm/module_base";
import ViewBase from "../framework/core/mvvm/view_base";
import ModelBase from "../framework/core/mvvm/model_base";
import ModuleManager from "../framework/core/module_manager";

// import PayForUtil from "../utility/payForUtil";
// import NoobGiftBeforeModule from "../pacakge/hall/module/noobGiftBefore/noobGiftBefore";
// import RankingMatchManager from "../pacakge/public/module/ranking_match/ranking_match_manager";
// import RankingMatchAward from "../pacakge/public/module/ranking_match/ranking_match_award";
// import BeginnerGuideUtil from "../utility/beginnerGuideUtil";
// import SevenDayAward from "../pacakge/hall/module/sevendayaward/sevendayaward";
// import NoobGiftModule from "../pacakge/hall/module/noobGift/noobGift";

let dialogQueue: any[] = []
dialogQueue.push("RankingMatchAward")
dialogQueue.push("Activity")
dialogQueue.push("DailySign")
dialogQueue.push("NoobGiftBeforeModule")
dialogQueue.push("PayForModule")
dialogQueue.push("BeginnerGuide")

dialogQueue.push("SpecialQrcode")//此处优先级最高

let uiQueue:any = [];

export class AutoDialogManager {
    static openPriorityDialog() {
        let length = dialogQueue.length
        if (length == 0) {
            return
        }
        let moduleName = dialogQueue[length - 1]
        dialogQueue.pop()
        this.dealModules(moduleName)
    }

    static pushUIQueue(moduleName:string,intentData?:any){
        let data = {
            moduleName:moduleName,
            intentData:intentData,
        }
        uiQueue.unshift(data);
    }

    static openPriorityUI(){
        let data = uiQueue.pop();
        if (data) {
            ModuleManager.instance.showModuleName(data.moduleName, data.intentData);
        }
    }


    private static dealModules(moduleName) {
        if (!moduleName) {
            return
        }
        cc.warn("打开模块：", moduleName)
        switch (moduleName) {
            // case "NoobGiftBeforeModule":
            //     this.showNoobgiftBeforeModule()
            //     break
            // case "DailySign":
            //     this.showDailySign(moduleName)
            //     break
            // case "PayForModule":
            //     this.showPayForModule()
            //     break
            // case "Activity":
            //     this.showActivity(moduleName)
            //     break
            // case "BeginnerGuide":
            //     this.showBeginnerGuide()
            //     break
            // case "SpecialQrcode":
            //     this.showSpecialQrcode()
            //     break
            // case "RankingMatchAward":
            //     this.showRankingMatchAward()
            //     break
            // default:
            //     ModuleManager.instance.showModuleName(moduleName, { auto: "auto" })
            //     break
        }
    }








}